/*
  中文
*/
export default {
  home: {}
}
